import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/users`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getUsers({ commit }, payload: { query: object }) {
    return axiosInstance.get(baseUrl, { params: payload ? payload.query : {} })
      .then((data) => data.data);
  },
  deleteUserById({ commit }, payload: { id: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  search({ commit }, payload: { search: string }) {
    return axiosInstance.get(`${baseUrl}/search`, { params: payload })
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
